import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

const root = ReactDOM.createRoot(document.getElementById('root'));
// axios.defaults.baseURL = "http://192.168.94.230:8000";
// axios.defaults.baseURL = "https://app.smartinvestordeck.ai/qxbox";
// axios.defaults.baseURL = "https://qa.smartinvestordeck.ai/api";
axios.defaults.baseURL = "https://qa.smartinvestordeck.ai/api";


if(sessionStorage.getItem("AdminToken")){
  axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("AdminToken")}` }
}
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
